<p>{{Question.prompt}}</p>
<input type="textbox" class="form-control" (ngModelChange)="handleChange($event)" [ngModel]="Question.answer" />


// WEBPACK FOOTER //
// ./src/app/assessments/question-textbox/question-textbox.component.html